module.exports = __webpack_public_path__ + "img/table_sort_arrow.90f765a2.svg";